import modalStyle from "../templates/Modal.style";
var modalData = {
  name: 'modal',
  data: [{
    showBgIcon: false,
    // 是否显示背景图标
    titleLineHeight: 22,
    titleFontSize: 16,
    contentFontColor: 14,
    contentLineHeight: 20,
    modalContentPadding: 0,
    bodyPadding: 16,
    modalBodyTextWeight: 400,
    footerPadding: 16,
    headerPosition: 'relative',
    headerPadding: '0.16rem 0.16rem 0.08rem',
    wrapBorderRadius: 2,
    modalFooterdispaly: 'block',
    hearderBorder: 'none',
    closeBtnTop: 6
  }],
  onlyTemplate: {
    pro: modalStyle
  }
};
export default modalData;